import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

export const getCerityProjects = createAsyncThunk(
  "certify/getCerityProjects",
  async (props) => {
    const { params, source } = props;
    try {
      const response = await axios.get(`/projects-certify`, {
        params,
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getProjectDetails = createAsyncThunk(
  "certify/getProjectDetails",
  async (props) => {
    const { id, source } = props;
    try {
      const response = await axios.get(`/projects-certify/get-project/${id}`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getCerityStatistics = createAsyncThunk(
  "certify/getCerityStatistics",
  async (props) => {
    const { params, source } = props;
    try {
      const response = await axios.get(`/projects-certify/statistics`, {
        params,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const createCreditScore = createAsyncThunk(
  "certify/createCreditScore",
  async (values) => {
    try {
      const response = await axios.post(
        `/projects-certify/credit-score`,
        values,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const addNewProjectScope = createAsyncThunk(
  "certify/addNewProjectScope",
  async (params) => {
    try {
      const { project_id } = params;

      const response = await axios.post(
        `/projects-certify/add-project-scope/${project_id}`,
        params,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateNewProjectScope = createAsyncThunk(
  "certify/updateNewProjectScope",
  async (params) => {
    try {
      const { id } = params;

      const response = await axios.post(
        `projects-certify/update-project-scope/${id}`,
        params,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const deleteNewProjectScope = createAsyncThunk(
  "certify/deleteNewProjectScope",
  async (params) => {
    try {
      const { id, project_id } = params;

      const response = await axios.delete(
        `projects-certify/delete-project-scope/${id}/${project_id}`,
        params,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const addProjectScopeByYear = createAsyncThunk(
  "certify/addProjectScopeByYear",
  async (params) => {
    try {
      const { project_id } = params;

      const response = await axios.post(
        `projects-certify/add-project-scope-by-year/${project_id}`,
        params,
      );

      const data = await response.data;

      return { ...data, params };
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateProjectScopeByYear = createAsyncThunk(
  "certify/updateProjectScopeByYear",
  async (params) => {
    try {
      const { ceiling_flow_id, project_id } = params;

      const response = await axios.post(
        `projects-certify/update-project-scope-by-year/${project_id}/${ceiling_flow_id}`,
        params,
      );

      const data = await response.data;

      return { ...data, params };
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateCeilingAmount = createAsyncThunk(
  "certify/updateCeilingAmount",
  async (params) => {
    try {
      const { ceiling_flow_id, project_id } = params;

      const response = await axios.post(
        `projects-certify/update-ceiling-amount/${project_id}/${ceiling_flow_id}`,
        params,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const saveRevisedScope = createAsyncThunk(
  "certify/saveRevisedScope",
  async (params) => {
    try {
      const { project_id } = params;

      const response = await axios.post(
        `projects-certify/save-revised-scope/${project_id}`,
        params,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateRevisedProjectProfile = createAsyncThunk(
  "certify/updateRevisedProjectProfile",
  async (params) => {
    try {
      const { project_id } = params;

      const response = await axios.post(
        `projects-certify/update-revised-project-profile/${project_id}`,
        params,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      console.error(error);
    }
  },
);
